import {
  fetchBscFinancialGoals,
  fetchBscCustomerValueGoals,
  fetchBscStrategicGoalGoals,
  fetchBscStrategicIssueGoals,
  fetchBscHumanCapitalGoalGoals,
  fetchBscInfoCapitalGoalAppGoals,
  fetchBscInfoCapitalGoalDataGoals,
  fetchBscInfoCapitalGoalItGoals,
  fetchBscOrgCapitalGoalGoals,
} from "../../../api/memberApi";

export const BSC_CATEGORY_CONFIG = {
  "financial-goals": { fetchGoals: fetchBscFinancialGoals, titleKey: "bsc.financialGoals.title" },
  "customer-values": { fetchGoals: fetchBscCustomerValueGoals, titleKey: "bsc.customerValues.title" },
  "strategic-goals": { fetchGoals: fetchBscStrategicGoalGoals, titleKey: "bsc.strategicGoals.title" },
  "strategic-issues": { fetchGoals: fetchBscStrategicIssueGoals, titleKey: "bsc.strategicIssues.title" },
  "human-capital-goals": { fetchGoals: fetchBscHumanCapitalGoalGoals, titleKey: "bsc.humanCapitalGoals.title" },
  "info-capital-goals-app": { fetchGoals: fetchBscInfoCapitalGoalAppGoals, titleKey: "bsc.infoCapitalGoalsApp.title" },
  "info-capital-goals-data": { fetchGoals: fetchBscInfoCapitalGoalDataGoals, titleKey: "bsc.infoCapitalGoalsData.title" },
  "info-capital-goals-it": { fetchGoals: fetchBscInfoCapitalGoalItGoals, titleKey: "bsc.infoCapitalGoalsIt.title" },
  "org-capital-goals": { fetchGoals: fetchBscOrgCapitalGoalGoals, titleKey: "bsc.orgCapitalGoals.title" },
};
